import { UserCombobox } from '@/components'
import VehicleSelect from '@/components/vehicle-select'
import type { DownloadTachoFilesMode } from './types'

interface DownloadTachoFilesEntitySelectProps {
  mode: DownloadTachoFilesMode
  value: string[]
  onChange(ids: string[]): void
  placeholder?: string
}

/**
 * Multi-select for the download prompt that always emits an array of ids,
 * rendering a user picker in driver mode and a vehicle picker in vehicle mode.
 */
export const DownloadTachoFilesEntitySelect: React.FC<
  DownloadTachoFilesEntitySelectProps
> = ({ mode, value, onChange, placeholder }) => {
  if (mode === 'vehicle')
    return (
      <VehicleSelect
        mode="multiple"
        value={value}
        placeholder={placeholder}
        onChange={vehicles => onChange(vehicles.map(vehicle => vehicle.id))}
      />
    )

  return (
    <UserCombobox
      mode="multiple"
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
  )
}
